import { Heading, Stack } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TrackedButton } from '$/components/common/Button/TrackedButton';
import { Icon } from '$/components/common/Icon';

interface Props {
  onReturn: () => void;
}

export const DeleteAccountHeader: FC<Props> = ({ onReturn }) => {
  const { t } = useTranslation();

  return (
    <Stack>
      <TrackedButton
        justifyContent='flex-start'
        gap='2'
        px='0'
        fontSize='sm'
        leftIcon={
          <Icon icon='arrow_right' w='14px' transform='rotate(180deg)' />
        }
        onClick={onReturn}
        variant='text'
        contentName='CloudAccount'
        contentPiece='DeleteAccount'
        contentTarget='Close'
      >
        {t('dashboard.authentication.profile.backToProfile')}
      </TrackedButton>
      <Heading fontSize='3xl' textAlign='center'>
        {t('dashboard.authentication.deleteAccount.action')}
      </Heading>
    </Stack>
  );
};
